import { render, staticRenderFns } from "./midi-pitches-counter.vue?vue&type=template&id=dd54b936"
import script from "./midi-pitches-counter.vue?vue&type=script&lang=js"
export * from "./midi-pitches-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports